import * as React from 'react';
import Box from "@material-ui/core/Box";
import {
    createStyles,
    Grid,
    IconButton,
    makeStyles,
    TextField
} from "@material-ui/core";
import { LocationOnOutlined, EditOutlined } from '@material-ui/icons';
import { useState } from "react";
import { ServicioAdicional as ServicioGuia } from "../../entities/catalogos/ServicioAdicional";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import NumberField from "../controls/NumberField";
import { useSnackbar } from "notistack";
import { traducirLabel, traducirMessage } from '../../blocks/traductor';
import HelpServiciosAdicionales from '../help/HelpServiciosAdicionales';
import { IDocumento } from "../../interfaces/IDocumento";
import RetornoDocumentosDialogGuia from "./RetornoDocumentosDialogGuia";
import { clonarDocumentosCliente } from "./retornoDocumentosGuiaHelpers";

const useStyles = makeStyles(() =>
    createStyles({
        iconCustomMaterial: {
            fontSize: 30
        },
        iconCustom: {
            width: "30px",
            height: "30px"
        },
        nameCard: {
            fontSize: "10px",
            padding: "0px 5px"
        },
        inputCantidad: {
            fontSize: "11px",
            height: "8px",
            "&::placeholder": {
                opacity: 1
            },
        }
    })
);

interface OwnProps {
    value: ServicioGuia
    onSelect: (servicio: ServicioGuia) => void
    documentosCliente: IDocumento[]
}

type Props = OwnProps;

const ServicioAdicionalItemGuia = (props: Props) => {
    const [servicio, setServicio] = useState<ServicioGuia>(props.value);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [headerAyuda, setHeaderAyuda] = useState("");
    const [descripcionAyuda, setDescripcionAyuda] = useState("");
    const { enqueueSnackbar } = useSnackbar();
    const estiloSeleccionado = servicio.seleccionado ? 'selected' : '';
    const estiloRequerido = servicio.esRequerido && !servicio.seleccionado ? 'required' : '';
    const classes = useStyles();
    const documentosClienteClon = clonarDocumentosCliente(props.documentosCliente);
    const nombreIcono = servicio.configuracion?.conceptoIcono
        ? servicio.configuracion.conceptoIcono.rutaIcono.split('.')[0]
        : null;
    const nombreIconoDisplay = servicio.seleccionado ? `${nombreIcono}_seleccionado.png` : `${nombreIcono}.png`;

    React.useEffect(() => {
        setServicio(props.value);
    }, [props.value]);

    React.useEffect(() => {
        const etiquetas = JSON.parse(localStorage.getItem("etiquetas") ?? "[]");
        const servicioId = props.value?.id ?? 0;
        const number = "000" + servicioId.toString();
        const claveEtiqueta = "lbl_servicio_adicional_" + number.substr(number.length - 3);
        if (etiquetas.length) {
            const etiqueta = etiquetas.find(a => a.clave === claveEtiqueta);
            if (etiqueta !== undefined) {
                if (localStorage.getItem("idioma") === 'en-US') {
                    setHeaderAyuda(
                        (props.value.etiquetaServicioAdicionalDto?.nombre === null
                            || props.value.etiquetaServicioAdicionalDto?.nombre === '')
                            ? props.value.nombre
                            : props.value.etiquetaServicioAdicionalDto?.nombre
                    );
                } else {
                    setHeaderAyuda(props.value.nombre);
                }
                setDescripcionAyuda(etiqueta.descripcion);
            }
        }
    }, [props.value]);

    const abrirDialogRetorno = () => {
        setDialogOpen(true);
    };

    const guardarRetornoDocumentos = (servicioActualizado: ServicioGuia) => {
        setServicio(servicioActualizado);
        props.onSelect(servicioActualizado);
        setDialogOpen(false);
    };

    const cerrarDialogRetorno = () => {
        setDialogOpen(false);
    };

    const editarRetornoDocumento = (event: React.MouseEvent) => {
        event.stopPropagation();
        abrirDialogRetorno();
    };

    const seleccionarServicio = () => {
        const copiaServicio = new ServicioGuia({ ...servicio });
        const eraSeleccionado = servicio.seleccionado;

        if (servicio.esRetornoDocumentos && !eraSeleccionado) {
            abrirDialogRetorno();
            return;
        }

        if (eraSeleccionado || copiaServicio.SeleccionarPorClick()) {
            if (eraSeleccionado) {
                if (servicio.esRetornoDocumentos) {
                    copiaServicio.Deseleccionar(documentosClienteClon);
                } else {
                    copiaServicio.Deseleccionar([]);
                }
            }
            setServicio(copiaServicio);
            props.onSelect(copiaServicio);
        } else {
            enqueueSnackbar(traducirMessage(105), { variant: "error" });
        }
    };

    const onChangeServicio = (propiedad: string, esCheck: boolean = false) => ({ target }) => {
        const value = esCheck ? target.checked : target.value;
        const copiaServicio = new ServicioGuia({ ...servicio, [propiedad]: value });
        if (propiedad !== "costo") {
            copiaServicio.CambiarValores();
        }
        setServicio(copiaServicio);
        props.onSelect(copiaServicio);
    };

    const nombreServicio = localStorage.getItem("idioma") === 'en-US'
        ? ((servicio.etiquetaServicioAdicionalDto?.nombre)
            || servicio.concepto?.etiquetaConcepto?.nombreConcepto
            || servicio.nombre)
        : (servicio.nombre || servicio.concepto?.nombreConcepto);

    return (
        <Grid item style={{ position: "relative" }}>
            <Box
                display="flex"
                className={`card small-height ${estiloSeleccionado} ${estiloRequerido}`}
                justifyContent="center"
                style={{ width: "187px", height: "170px" }}
            >
                <Box display="flex" justifyContent="center" alignItems="center" flexDirection="column" pt={1}>
                    <Box style={{ width: "150px", textAlign: "center" }}>
                        <Box onClick={seleccionarServicio} pb={1} style={{ cursor: "pointer" }}>
                            {servicio.configuracion?.conceptoIcono ? (
                                <img
                                    src={"/image/iconosSitioExterno/" + nombreIconoDisplay}
                                    alt=""
                                    className={classes.iconCustom}
                                />
                            ) : (
                                <LocationOnOutlined className={classes.iconCustomMaterial} />
                            )}
                            <Box className={classes.nameCard + " title-4 text-center"}>
                                <b>{nombreServicio}</b>
                            </Box>
                        </Box>

                        <Grid container spacing={1}>
                            <Grid item xs={6} className="chk-xs" style={{ textAlign: 'start' }}>
                                {servicio.mostrarCheckOrigen && (
                                    <FormControlLabel
                                        label={traducirLabel(222)}
                                        control={
                                            <Checkbox
                                                checked={servicio.aplicaOrigen ?? false}
                                                onChange={onChangeServicio("aplicaOrigen", true)}
                                                color="primary"
                                                size="small"
                                            />
                                        }
                                    />
                                )}
                            </Grid>
                            <Grid item xs={6}>
                                {servicio.mostrarCantidadOrigen && (
                                    <TextField
                                        placeholder={traducirLabel(29)}
                                        value={servicio.cantidadOrigen}
                                        disabled={!servicio.aplicaOrigen}
                                        onChange={onChangeServicio("cantidadOrigen")}
                                        InputProps={{
                                            classes: { input: classes.inputCantidad },
                                            inputComponent: NumberField as any,
                                            inputProps: { precision: 0, maxLength: 3 },
                                        }}
                                    />
                                )}
                            </Grid>
                            {servicio.mostrarCheckDestino && (
                                <Grid item xs={6} className="chk-xs" style={{ textAlign: 'start' }}>
                                    <FormControlLabel
                                        label={traducirLabel(86)}
                                        control={
                                            <Checkbox
                                                checked={servicio.aplicaDestino ?? false}
                                                onChange={onChangeServicio("aplicaDestino", true)}
                                                disabled={servicio.destinoSeleccionado}
                                                color="primary"
                                                size="small"
                                            />
                                        }
                                    />
                                </Grid>
                            )}
                            {!servicio.mostrarCheckDestino && (
                                <Grid item xs={6} className="chk-xs" style={{ textAlign: 'start' }} />
                            )}
                            <Grid item xs={6}>
                                {servicio.mostrarCantidadDestino && (
                                    <TextField
                                        placeholder={traducirLabel(29)}
                                        value={servicio.cantidadDestino}
                                        disabled={!servicio.aplicaDestino}
                                        onChange={onChangeServicio("cantidadDestino")}
                                        InputProps={{
                                            classes: { input: classes.inputCantidad },
                                            inputComponent: NumberField as any,
                                            inputProps: { precision: 0, maxLength: 3 },
                                        }}
                                    />
                                )}
                            </Grid>
                            {servicio.esAbierto && (
                                <Grid item xs={6}>
                                    <TextField
                                        placeholder={traducirLabel(56)}
                                        value={servicio.costo}
                                        onChange={onChangeServicio("costo")}
                                        disabled={!servicio.seleccionado}
                                        InputProps={{
                                            classes: { input: classes.inputCantidad },
                                            inputComponent: NumberField as any,
                                            inputProps: { prefix: '$', precision: 2, maxLength: 10 },
                                        }}
                                    />
                                </Grid>
                            )}
                        </Grid>
                    </Box>
                </Box>
            </Box>
            {servicio.esRetornoDocumentos && servicio.seleccionado && (
                <div style={{ position: "absolute", top: "10px", left: "10px" }}>
                    <IconButton size="small" style={{ color: "white" }} onClick={editarRetornoDocumento}>
                        <EditOutlined />
                    </IconButton>
                </div>
            )}
            {!servicio.seleccionado &&
                <HelpServiciosAdicionales
                    comments={descripcionAyuda}
                    ayuda={headerAyuda}
                    customStyle={{ bottom: "80px", right: "-5px" }}
                    size="small"
                />}
            {servicio.seleccionado &&
                <HelpServiciosAdicionales
                    comments={descripcionAyuda}
                    ayuda={headerAyuda}
                    customStyle={{ bottom: "80px", right: "-5px", color: "#FFF" }}
                    size="small"
                />}
            {servicio.esRetornoDocumentos && (
                <RetornoDocumentosDialogGuia
                    open={dialogOpen}
                    servicio={servicio}
                    documentosCliente={documentosClienteClon}
                    onGuardar={guardarRetornoDocumentos}
                    onCerrar={cerrarDialogRetorno}
                />
            )}
        </Grid>
    );
};

export default ServicioAdicionalItemGuia;
